import { Fragment, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useAuth } from '../../context/AuthContext';
import { OverviewCurrencyProvider } from '../../context/OverviewCurrencyContext';
import { Navigate } from 'react-router-dom';
import OnboardingModal from '../../components/OnboardingModal/OnboardingModal';
import { LocaleContext } from '../../context/LocaleContext';
import { OverviewRefreshProvider } from '../../context/OverviewRefreshContext';
import { SidebarMenu } from '../../components/sidebar-menu';
import { SidebarHeader } from '../../ui/sidebar-header/ui/sidebar-header';
import { NotificationsProvider } from '../../entities/notification';
import { Spinner } from '../../shared/ui/spinner';

import styles from './LayoutAuth.module.css';

export const LayoutAuth = ({ children }) => {
	const intl = useIntl();
	const { isAuth, fetchMe, isLoading, userInfo } = useAuth();
	const hasFetched = useRef(false);

	useEffect(() => {
		const token = localStorage.getItem('accessToken');

		if (token && !isAuth && !hasFetched.current && !isLoading) {
			hasFetched.current = true;

			const fetchData = async () => {
				try {
					await fetchMe();
				} catch (error) {
					console.error('Failed to fetch user:', error);
					hasFetched.current = false;
				}
			};

			fetchData();
		}
	}, [isAuth, fetchMe, isLoading]);

	if (isLoading) return <Spinner />;

	if (!isAuth) return <Navigate to='/' />;

	return (
		<OverviewCurrencyProvider>
			<OverviewRefreshProvider>
				<NotificationsProvider>
					<div className={styles.shell}>
						<SidebarMenu />
						<div className={styles.main}>
							<LocaleContext.Consumer>
								{() => (
									<Fragment>
										<div className={styles.header}>
											<SidebarHeader />
										</div>
										<main className={styles.page}>{children}</main>
										<footer className={styles.copyright}>
											<p>{intl.formatMessage({ id: 'FooterId6' })}</p>
										</footer>
									</Fragment>
								)}
							</LocaleContext.Consumer>
						</div>
						<OnboardingModal userInfo={userInfo} fetchMe={fetchMe} />
					</div>
				</NotificationsProvider>
			</OverviewRefreshProvider>
		</OverviewCurrencyProvider>
	);
};
